<script>
  import MoreMenu from './widgets/more-menu.svelte'

  import Sidebar from './sidebar.svelte'
  import Toasts from './toast'


  export let currentView
  export let title
  export let moreMenuItems

  let drawerClosed = true
  let removeOutsideClickHandler

  const closeSidebar = function () {
    if (!drawerClosed) {
      drawerClosed = true
      removeOutsideClickHandler()
    }
  }

  const openSidebar = function () {
    if (drawerClosed) {
      const sidebarElement = document.querySelector('.sidebar')
      const sidebarButtonElement = document.querySelector('.sidebarButton')

      const outsideClickListener = function (event) {
        if (!(sidebarElement.contains(event.target) || sidebarButtonElement.contains(event.target))) {
          closeSidebar()
        }
      }

      removeOutsideClickHandler = function () {
        document.removeEventListener('click', outsideClickListener)
        removeOutsideClickHandler = undefined
      }

      drawerClosed = false
      document.addEventListener('click', outsideClickListener)
    }
  }

  const toggleSidebar = function () {
    if (drawerClosed) {
      openSidebar()
    } else {
      closeSidebar()
    }
  }
</script>

<Sidebar {currentView} {drawerClosed} on:closeDrawer={closeSidebar} />
<header>
  <button class="sidebarButton iconButton" on:click={toggleSidebar} title="Menu">
    <svg class="icon" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 6h16M4 12h8m-8 6h16">
      </path>
    </svg>
  </button>
  {#if title}
    <h4>{title}</h4>
  {/if}
  <div class="spacer"></div>
  {#if moreMenuItems && moreMenuItems.length}
    <MoreMenu menuItems={moreMenuItems} position="belowLeft" />
  {/if}
</header>
<main>
  <slot />
  <Toasts />
</main>
<slot name="controls" />

<style>
  header h4 {
    align-self: center;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
